// extracted by mini-css-extract-plugin
export default {"placeholder":"BrandPlaceholder_placeholder__YJccP","icon":"BrandPlaceholder_icon__G3vUN","message":"BrandPlaceholder_message__Hnw5Z"};